(function () {
/**
 * If browser back button was used, flush cache
 * This ensures that user will always see an accurate, up-to-date view based on their state
 * https://stackoverflow.com/questions/8788802/prevent-safari-loading-from-cache-when-back-button-is-clicked
 */ (function() {
    window.onpageshow = function(event) {
        if (event.persisted) window.location.reload();
    };
})();


/**

 /\                 /\
/ \'._   (\_/)   _.'/ \
|.''._'--(o.o)--'_.''.|
 \_ / `;=/ " \=;` \ _/
   `\__| \___/ |__/`
        \(_|_)/
         " ` "

I came, I saw, I conquered

 */ /*

==================================================================================================

CUSTOM CLASSES / WRAPPERS

==================================================================================================


/**
 * A wrapper for a dynamic fully loaded async cart
 *
 * @class cartFlyout
 * @typedef {CartFlyout}
 * @extends {HTMLElement}
 */ let $271d41e42b23a57b$var$isCheckingGWP = false;
class $271d41e42b23a57b$var$CartFlyout extends HTMLElement {
    constructor(){
        super();
        // bind the escape key to always close the cart
        document.addEventListener('keyup', (e)=>{
            if (e.key === 'Escape') {
                if (this.classList.contains('open')) this.close();
                else return false;
            }
        });
        // used for cart abandon
        const urlParams = new URLSearchParams(window.location.search);
        const shouldCartOpenFromParams = urlParams.get('bag-open');
        // console.log(shouldCartOpenFromParams);
        if (shouldCartOpenFromParams) {
            // this.open();
            this.setAttribute('data-open', true);
            this.classList.add('open');
            document.querySelector('body').classList.add('body-locked');
            document.querySelector('cart-overlay').classList.add('open');
        }
    }
    render() {
        this.setAttribute('cart-ref', '');
    }
    connectedCallback() {
        this.render();
        $271d41e42b23a57b$var$checkGWP();
        $271d41e42b23a57b$var$loadCartRecommendations();
    }
    // if the theme settings has the cart flyout enabled, oprn it
    // if not, then redirect to cart page
    open() {
        this.setAttribute('data-open', true);
        let isEnabled = this.getAttribute('data-enabled');
        if (!isEnabled || isEnabled == 'false') {
            window.location.href = window?.Shopify?.routes?.root + 'cart';
            return false;
        } else if (window.location.pathname == '/cart') return false;
        else {
            this.classList.add('open');
            document.querySelector('body').classList.add('body-locked');
            document.querySelector('cart-overlay').classList.add('open');
            $271d41e42b23a57b$var$checkGWP();
            $271d41e42b23a57b$var$loadCartRecommendations();
        }
    }
    close() {
        this.setAttribute('data-open', false);
        this.classList.remove('open');
        document.querySelector('body').classList.remove('body-locked');
        document.querySelector('cart-overlay').classList.remove('open');
    }
    /**
   * Helper for quickly returning the amounf of items in cart
   *
   * @async
   * @returns {Number} - cart count
   */ async getCount() {
        try {
            const response = await fetch(window.Shopify.routes.root + 'cart.js', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const res = await response.json();
            return res?.item_count;
        } catch (error) {
            console.error('Error:', error);
        }
    }
}
customElements.define('cart-flyout', $271d41e42b23a57b$var$CartFlyout);
// Create a new cart instance and call the methods from outside their classes
const $271d41e42b23a57b$var$_default = document.querySelector(`[cart-ref]`);
class $271d41e42b23a57b$var$CartCounter extends HTMLElement {
    constructor(){
        super();
    }
    // watch for changes in the selected checkout option
    static get observedAttributes() {
        return [
            'data-in-sync'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue != null) this.resync();
    }
    async render() {
        let c = await $271d41e42b23a57b$var$_default.getCount();
        this.setAttribute('counter-ref', '');
        this.setAttribute('data-count', c);
    }
    async resync() {
        let c = await $271d41e42b23a57b$var$_default.getCount();
        this.setAttribute('data-count', c);
        this.innerHTML = `${c}`;
    }
    connectedCallback() {
        this.render();
    }
}
customElements.define('cart-count', $271d41e42b23a57b$var$CartCounter);
let $271d41e42b23a57b$var$_counter = document.querySelector(`cart-count`);
/**
 * Quantity adjusters for items in the cart
 *
 * @class cartFlyoutQuantity
 * @typedef {CartFlyoutQuantity}
 * @extends {CartFlyout}
 */ class $271d41e42b23a57b$var$CartFlyoutQuantity extends $271d41e42b23a57b$var$CartFlyout {
    constructor(){
        super();
        this.addEventListener('click', (e)=>{
            let _type = e.currentTarget.getAttribute('data-type');
            let _amount = parseInt(e.currentTarget.getAttribute('data-current'));
            this.adjustQuantity(_type, _amount);
        });
    }
    adjustQuantity(t, a) {
        $271d41e42b23a57b$var$_counter.setAttribute('data-in-sync', false);
        if (t == 'up') {
            a = a + 1;
            this.hydrateCartItem(a);
        } else {
            a = a - 1;
            this.hydrateCartItem(a);
        }
    }
    async hydrateCartItem(a) {
        let k = this.getAttribute('data-key');
        let updates = {
            [k]: a
        };
        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    updates: updates
                })
            });
            const res = await response.json();
            $271d41e42b23a57b$var$resyncCart();
        } catch (error) {
            console.error('Error:', error);
        }
    }
}
customElements.define('cart-flyout-quantity', $271d41e42b23a57b$var$CartFlyoutQuantity);
/**
 * A wrapepr for removing all quantities of a given line item
 *
 * @class cartItemRemove
 * @typedef {CartItemRemove}
 * @extends {CartFlyout}
 */ class $271d41e42b23a57b$var$CartItemRemove extends $271d41e42b23a57b$var$CartFlyout {
    constructor(){
        super();
        this.addEventListener('click', (e)=>{
            let _key = e.currentTarget.getAttribute('data-key');
            this.kill(_key);
        });
    }
    /**
   * Remove the given line item from the attached cart
   *
   * @async
   * @param {*} _id
   * @returns {object} Cart object
   */ async kill(_id) {
        let updates = {
            [_id]: 0
        };
        $271d41e42b23a57b$var$_counter.setAttribute('data-in-sync', false);
        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    updates: updates
                })
            });
            const res = await response.json();
            $271d41e42b23a57b$var$resyncCart();
            return res;
        } catch (error) {
            console.error('Error:', error);
        }
    }
}
customElements.define('cart-flyout-remove', $271d41e42b23a57b$var$CartItemRemove);
/**
 * Button for easily adding items to the cart - 1 quantity at a time
 *
 * @class AddToCart
 * @typedef {AddToCart}
 * @extends {HTMLElement}
 */ class $271d41e42b23a57b$var$AddToCart extends HTMLElement {
    constructor(){
        super();
        this.addEventListener('click', ()=>{
            if (this.hasAttribute('disabled')) return;
            this.addOnce();
        });
    }
    async addOnce() {
        document.querySelector('cart-flyout').classList.add('waiting');
        document.querySelector('#awaiting').classList.add('waiting');
        const props = this.querySelectorAll('[js-props]');
        let _props = [];
        if (props.length > 0) props.forEach((el)=>{
            let _key = el.getAttribute('name');
            let _val = el.value;
            _props.push({
                [_key]: _val
            });
        });
        _props = Object.assign({}, ..._props);
        $271d41e42b23a57b$var$_counter.setAttribute('data-in-sync', false);
        let i = this.getAttribute('data-id');
        let q = this.getAttribute('data-quantity');
        // if props aren't empty, add them to the cart
        let formData = {
            items: [
                {
                    id: i,
                    quantity: parseInt(q) || 1,
                    properties: _props
                }
            ]
        };
        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });
            const res = await response.json();
            $271d41e42b23a57b$var$resyncCart();
        } catch (error) {
            console.error('Error:', error);
        }
        document.querySelector('cart-flyout').classList.remove('waiting');
        $271d41e42b23a57b$var$_default.open();
    }
}
customElements.define('add-to-cart', $271d41e42b23a57b$var$AddToCart);
class $271d41e42b23a57b$var$ProductQuantity extends $271d41e42b23a57b$var$CartFlyout {
    constructor(){
        super();
        this.addEventListener('click', (e)=>{
            e.preventDefault();
            this.determineAmounts();
        });
    }
    determineAmounts() {
        let _id = this.getAttribute('data-id');
        let _type = this.getAttribute('data-type');
        let _q = parseInt(document.querySelector(`#dq-${_id}`).getAttribute('data-current'));
        if (_type == 'up') {
            _q = _q + 1;
            document.querySelector(`#dq-${_id}`).setAttribute('data-current', _q);
            document.querySelector(`#atc-${_id}`).setAttribute('data-quantity', _q);
            document.querySelector(`#dq-${_id}`).innerHTML = _q;
        } else {
            if (_q == 1) return false;
            else {
                _q = _q - 1;
                document.querySelector(`#dq-${_id}`).setAttribute('data-current', _q);
                document.querySelector(`#atc-${_id}`).setAttribute('data-quantity', _q);
                document.querySelector(`#dq-${_id}`).innerHTML = _q;
            }
        }
    }
}
customElements.define('product-quantity', $271d41e42b23a57b$var$ProductQuantity);
/**
 * Cart bg overlay with event handler
 *
 * @class CartOverlay
 * @typedef {CartOverlay}
 * @extends {HTMLElement}
 */ class $271d41e42b23a57b$var$CartOverlay extends HTMLElement {
    constructor(){
        super();
        this.addEventListener('click', (e)=>{
            $271d41e42b23a57b$var$_default.close();
        });
    }
}
customElements.define('cart-overlay', $271d41e42b23a57b$var$CartOverlay);
/*

==================================================================================================

UTILITIES

==================================================================================================


*/ /**
 * A useful way for detetcing when elements are added to the DOM via async code
 *
 * @param {string} selector - any valid query selector
 * @returns {*}
 */ const $271d41e42b23a57b$var$waitForElm = (selector)=>{
    return new Promise((resolve)=>{
        if (document.querySelector(selector)) return resolve(document.querySelector(selector));
        const observer = new MutationObserver((mutations)=>{
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
};
async function $271d41e42b23a57b$var$checkGWP() {
    if ($271d41e42b23a57b$var$isCheckingGWP) return false;
    $271d41e42b23a57b$var$isCheckingGWP = true;
    const cartFlyout = document.querySelector('cart-flyout');
    if (!cartFlyout) {
        $271d41e42b23a57b$var$isCheckingGWP = false;
        return false;
    }
    const enabled = cartFlyout.getAttribute('data-gwp-enabled') === 'true';
    const variantId = cartFlyout.getAttribute('data-gwp-variant-id');
    const threshold = parseFloat(cartFlyout.getAttribute('data-gwp-threshold')) * 100;
    if (!enabled || !variantId) {
        $271d41e42b23a57b$var$isCheckingGWP = false;
        return false;
    }
    try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await response.json();
        const gwpAutoItem = cart.items.find((item)=>{
            const isMatch = item.variant_id.toString() === variantId.toString() || item.id.toString() === variantId.toString();
            return isMatch && item.properties && item.properties._gwp_auto === 'true';
        });
        const gwpManualItem = cart.items.find((item)=>{
            const isMatch = item.variant_id.toString() === variantId.toString() || item.id.toString() === variantId.toString();
            return isMatch && (!item.properties || item.properties._gwp_auto !== 'true');
        });
        let gwpPrice = 0;
        cart.items.forEach((item)=>{
            const isMatch = item.variant_id.toString() === variantId.toString() || item.id.toString() === variantId.toString();
            if (isMatch) gwpPrice += item.final_line_price;
        });
        const qualifyingSubtotal = cart.total_price - gwpPrice;
        if (qualifyingSubtotal >= threshold) {
            if (gwpManualItem) {
                if (gwpAutoItem) {
                    const updates = {
                        [gwpAutoItem.key]: 0
                    };
                    await fetch(window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            updates: updates
                        })
                    });
                    await $271d41e42b23a57b$var$resyncCart(true);
                    return true;
                } else if (gwpManualItem.quantity !== 1) {
                    const updates = {
                        [gwpManualItem.key]: 1
                    };
                    await fetch(window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            updates: updates
                        })
                    });
                    await $271d41e42b23a57b$var$resyncCart(true);
                    return true;
                }
            } else {
                if (!gwpAutoItem) {
                    await fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            items: [
                                {
                                    id: variantId,
                                    quantity: 1,
                                    properties: {
                                        _gwp_auto: 'true'
                                    }
                                }
                            ]
                        })
                    });
                    await $271d41e42b23a57b$var$resyncCart(true);
                    return true;
                } else if (gwpAutoItem.quantity !== 1) {
                    const updates = {
                        [gwpAutoItem.key]: 1
                    };
                    await fetch(window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            updates: updates
                        })
                    });
                    await $271d41e42b23a57b$var$resyncCart(true);
                    return true;
                }
            }
        } else if (gwpAutoItem) {
            const updates = {
                [gwpAutoItem.key]: 0
            };
            await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    updates: updates
                })
            });
            await $271d41e42b23a57b$var$resyncCart(true);
            return true;
        }
    } catch (error) {
        console.error(error);
    } finally{
        $271d41e42b23a57b$var$isCheckingGWP = false;
    }
    return false;
}
/**
 * Update the cart and re sync with the liquid template in 1 action 🎩
 *
 * @async
 * @param {*} _id
 * @returns {object} Cart object
 */ async function $271d41e42b23a57b$var$resyncCart(skipGwpCheck = false) {
    if (!skipGwpCheck) {
        const mutated = await $271d41e42b23a57b$var$checkGWP();
        if (mutated) return;
    }
    document.querySelector('cart-flyout').classList.add('waiting');
    document.querySelector('#awaiting').classList.add('waiting');
    let _spooky = await $271d41e42b23a57b$var$_default.getCount();
    let _original = document.querySelector('.spooky-skeleton');
    if (_original) for(let i = 1; i < _spooky; i++){
        let _new = _original.cloneNode(true);
        document.querySelector('#awaiting').appendChild(_new);
    }
    try {
        const response = await fetch(window.Shopify.routes.root + 'cart?view=sync');
        const res = await response.text();
        let p = new DOMParser();
        let doc = p.parseFromString(res, 'text/html');
        let template = doc.querySelector('#main-cart #aside-cart-contents');
        let original = document.querySelector('#main-cart');
        let prev = document.querySelector('#main-cart #aside-cart-contents');
        doc.querySelectorAll('[data-cart-close="true"]').forEach((el)=>{
            el.addEventListener('click', ()=>{
                $271d41e42b23a57b$var$_default.close();
            });
        });
        original.replaceChild(template, prev);
        $271d41e42b23a57b$var$_counter.setAttribute('data-in-sync', true);
        document.querySelectorAll('[data-cart-close="true"]').forEach((el)=>{
            el.addEventListener('click', ()=>{
                $271d41e42b23a57b$var$_default.close();
            });
        });
        $271d41e42b23a57b$var$loadCartRecommendations();
    } catch (error) {
        console.error('Error:', error);
    }
    document.querySelector('cart-flyout').classList.remove('waiting');
}
let $271d41e42b23a57b$var$isFetchingRecommendations = false;
let $271d41e42b23a57b$var$lastLoadedProductId = null;
/**
 * Fetch and render product recommendations inside the cart flyout drawer
 *
 * @async
 * @returns {Promise<void>}
 */ async function $271d41e42b23a57b$var$loadCartRecommendations() {
    const wrapper = document.querySelector('#cart-recommendations-wrapper');
    const container = document.querySelector('.js-cart-recommendations-content');
    if (!wrapper || !container) return;
    const productId = wrapper.getAttribute('data-product-id');
    if (!productId) {
        wrapper.style.display = 'none';
        $271d41e42b23a57b$var$lastLoadedProductId = null;
        return;
    }
    if ($271d41e42b23a57b$var$isFetchingRecommendations) return;
    if ($271d41e42b23a57b$var$lastLoadedProductId === productId && container.children.length > 0) {
        wrapper.style.display = 'block';
        return;
    }
    $271d41e42b23a57b$var$isFetchingRecommendations = true;
    try {
        const rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
        const url = `${rootPath}recommendations/products?section_id=cart-drawer-recommendations&product_id=${productId}&limit=4`;
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const content = doc.querySelector('.aside-cart__recommendations-list');
        if (content && content.children.length > 0) {
            container.innerHTML = content.outerHTML;
            wrapper.style.display = 'block';
            $271d41e42b23a57b$var$lastLoadedProductId = productId;
            const accordion = wrapper.querySelector('custom-accordion');
            if (accordion && typeof accordion.init === 'function') accordion.init();
            window.dispatchEvent(new CustomEvent('cart:recommendations:loaded', {
                bubbles: true,
                detail: {
                    productId: productId,
                    count: content.children.length
                }
            }));
        } else {
            wrapper.style.display = 'none';
            $271d41e42b23a57b$var$lastLoadedProductId = null;
        }
    } catch (error) {
        console.error('Failed to load cart recommendations:', error);
        wrapper.style.display = 'none';
        $271d41e42b23a57b$var$lastLoadedProductId = null;
    } finally{
        $271d41e42b23a57b$var$isFetchingRecommendations = false;
    }
}
window.loadCartRecommendations = $271d41e42b23a57b$var$loadCartRecommendations;
// Make resyncCart available globally
window.resyncCart = $271d41e42b23a57b$var$resyncCart;
// Open the cart any time a trigger is clicked
document.querySelectorAll('[data-cart-trigger="true"]').forEach((el)=>{
    el.addEventListener('click', ()=>{
        $271d41e42b23a57b$var$_default.open();
    });
});
// Close the cart any time a trigger is clicked
document.querySelectorAll('[data-cart-close="true"]').forEach((el)=>{
    el.addEventListener('click', ()=>{
        $271d41e42b23a57b$var$_default.close();
    });
});


class $9aab986992895f88$var$customAccordion extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.init();
    }
    disconnectedCallback() {
        if (this.accordionTriggers && this.accordionTriggers.length > 0) this.accordionTriggers.forEach((trigger)=>{
            trigger.removeEventListener('click', this.handleTriggerClick);
        });
    }
    init() {
        this.accordionTriggers = this.querySelectorAll('.js-accordion-trigger');
        if (this.accordionTriggers.length > 0) this.accordionTriggers.forEach((trigger)=>{
            trigger.removeEventListener('click', this.handleTriggerClick);
            trigger.addEventListener('click', this.handleTriggerClick);
        });
    }
    handleTriggerClick = (e)=>{
        this.toggleType(e);
    };
    toggleType(e) {
        let type = this.getAttribute('data-type');
        let triggerBtn = e.target.nodeType === 'BUTTON' ? e.target : e.target.closest('button');
        if (type === 'only-one') {
            var timer = 0;
            this.accordionTriggers.forEach((trigger)=>{
                if (trigger !== triggerBtn) {
                    if (trigger.getAttribute('aria-expanded') === 'true') timer = 800;
                    trigger.setAttribute('aria-expanded', 'false');
                    if (trigger.nextElementSibling) trigger.nextElementSibling.setAttribute('aria-hidden', 'true');
                    const wrapper = trigger.closest('.aside-cart__recommendations-wrapper');
                    if (wrapper) wrapper.classList.remove('is-open');
                }
            });
            setTimeout(()=>{
                this.toggleAccordion(triggerBtn);
            }, timer);
        } else this.toggleAccordion(triggerBtn);
    }
    toggleAccordion(accordionBtn) {
        if (!accordionBtn) return;
        let isExpanded = accordionBtn.getAttribute('aria-expanded') === 'true';
        accordionBtn.setAttribute('aria-expanded', !isExpanded);
        if (accordionBtn.nextElementSibling) accordionBtn.nextElementSibling.setAttribute('aria-hidden', isExpanded);
        const wrapper = accordionBtn.closest('.aside-cart__recommendations-wrapper');
        if (wrapper) wrapper.classList.toggle('is-open', !isExpanded);
        if (!isExpanded) setTimeout(()=>{
            const scrollContainer = accordionBtn.closest('.aside-cart__inner');
            if (scrollContainer && wrapper) {
                const targetTop = wrapper.offsetTop - 10;
                scrollContainer.scrollTo({
                    top: targetTop,
                    behavior: 'smooth'
                });
            }
        }, 250);
        this.dispatchEvent(new CustomEvent('accordion:toggle', {
            bubbles: true,
            detail: {
                expanded: !isExpanded,
                trigger: accordionBtn
            }
        }));
    }
}
if (!customElements.get('custom-accordion')) customElements.define('custom-accordion', $9aab986992895f88$var$customAccordion);


function $d65d5652050191ad$var$isNumber(subject) {
    return typeof subject === 'number';
}
function $d65d5652050191ad$var$isString(subject) {
    return typeof subject === 'string';
}
function $d65d5652050191ad$var$isBoolean(subject) {
    return typeof subject === 'boolean';
}
function $d65d5652050191ad$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === '[object Object]';
}
function $d65d5652050191ad$var$mathAbs(n) {
    return Math.abs(n);
}
function $d65d5652050191ad$var$mathSign(n) {
    return Math.sign(n);
}
function $d65d5652050191ad$var$deltaAbs(valueB, valueA) {
    return $d65d5652050191ad$var$mathAbs(valueB - valueA);
}
function $d65d5652050191ad$var$factorAbs(valueB, valueA) {
    if (valueB === 0 || valueA === 0) return 0;
    if ($d65d5652050191ad$var$mathAbs(valueB) <= $d65d5652050191ad$var$mathAbs(valueA)) return 0;
    const diff = $d65d5652050191ad$var$deltaAbs($d65d5652050191ad$var$mathAbs(valueB), $d65d5652050191ad$var$mathAbs(valueA));
    return $d65d5652050191ad$var$mathAbs(diff / valueB);
}
function $d65d5652050191ad$var$arrayKeys(array) {
    return $d65d5652050191ad$var$objectKeys(array).map(Number);
}
function $d65d5652050191ad$var$arrayLast(array) {
    return array[$d65d5652050191ad$var$arrayLastIndex(array)];
}
function $d65d5652050191ad$var$arrayLastIndex(array) {
    return Math.max(0, array.length - 1);
}
function $d65d5652050191ad$var$arrayIsLastIndex(array, index) {
    return index === $d65d5652050191ad$var$arrayLastIndex(array);
}
function $d65d5652050191ad$var$arrayFromNumber(n, startAt = 0) {
    return Array.from(Array(n), (_, i)=>startAt + i);
}
function $d65d5652050191ad$var$objectKeys(object) {
    return Object.keys(object);
}
function $d65d5652050191ad$var$objectsMergeDeep(objectA, objectB) {
    return [
        objectA,
        objectB
    ].reduce((mergedObjects, currentObject)=>{
        $d65d5652050191ad$var$objectKeys(currentObject).forEach((key)=>{
            const valueA = mergedObjects[key];
            const valueB = currentObject[key];
            const areObjects = $d65d5652050191ad$var$isObject(valueA) && $d65d5652050191ad$var$isObject(valueB);
            mergedObjects[key] = areObjects ? $d65d5652050191ad$var$objectsMergeDeep(valueA, valueB) : valueB;
        });
        return mergedObjects;
    }, {});
}
function $d65d5652050191ad$var$isMouseEvent(evt, ownerWindow) {
    return typeof ownerWindow.MouseEvent !== 'undefined' && evt instanceof ownerWindow.MouseEvent;
}
function $d65d5652050191ad$var$Alignment(align, viewSize) {
    const predefined = {
        start: start,
        center: center,
        end: end
    };
    function start() {
        return 0;
    }
    function center(n) {
        return end(n) / 2;
    }
    function end(n) {
        return viewSize - n;
    }
    function measure(n, index) {
        if ($d65d5652050191ad$var$isString(align)) return predefined[align](n);
        return align(viewSize, n, index);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $d65d5652050191ad$var$EventStore() {
    let listeners = [];
    function add(node, type, handler, options = {
        passive: true
    }) {
        let removeListener;
        if ('addEventListener' in node) {
            node.addEventListener(type, handler, options);
            removeListener = ()=>node.removeEventListener(type, handler, options);
        } else {
            const legacyMediaQueryList = node;
            legacyMediaQueryList.addListener(handler);
            removeListener = ()=>legacyMediaQueryList.removeListener(handler);
        }
        listeners.push(removeListener);
        return self;
    }
    function clear() {
        listeners = listeners.filter((remove)=>remove());
    }
    const self = {
        add: add,
        clear: clear
    };
    return self;
}
function $d65d5652050191ad$var$Animations(ownerDocument, ownerWindow, update, render) {
    const documentVisibleHandler = $d65d5652050191ad$var$EventStore();
    const timeStep = 1000 / 60;
    let lastTimeStamp = null;
    let lag = 0;
    let animationFrame = 0;
    function init() {
        documentVisibleHandler.add(ownerDocument, 'visibilitychange', ()=>{
            if (ownerDocument.hidden) reset();
        });
    }
    function destroy() {
        stop();
        documentVisibleHandler.clear();
    }
    function animate(timeStamp) {
        if (!animationFrame) return;
        if (!lastTimeStamp) lastTimeStamp = timeStamp;
        const elapsed = timeStamp - lastTimeStamp;
        lastTimeStamp = timeStamp;
        lag += elapsed;
        while(lag >= timeStep){
            update();
            lag -= timeStep;
        }
        const lagOffset = $d65d5652050191ad$var$mathAbs(lag / timeStep);
        render(lagOffset);
        if (animationFrame) ownerWindow.requestAnimationFrame(animate);
    }
    function start() {
        if (animationFrame) return;
        animationFrame = ownerWindow.requestAnimationFrame(animate);
    }
    function stop() {
        ownerWindow.cancelAnimationFrame(animationFrame);
        lastTimeStamp = null;
        lag = 0;
        animationFrame = 0;
    }
    function reset() {
        lastTimeStamp = null;
        lag = 0;
    }
    const self = {
        init: init,
        destroy: destroy,
        start: start,
        stop: stop,
        update: update,
        render: render
    };
    return self;
}
function $d65d5652050191ad$var$Axis(axis, contentDirection) {
    const isRightToLeft = contentDirection === 'rtl';
    const isVertical = axis === 'y';
    const scroll = isVertical ? 'y' : 'x';
    const cross = isVertical ? 'x' : 'y';
    const sign = !isVertical && isRightToLeft ? -1 : 1;
    const startEdge = getStartEdge();
    const endEdge = getEndEdge();
    function measureSize(nodeRect) {
        const { height: height, width: width } = nodeRect;
        return isVertical ? height : width;
    }
    function getStartEdge() {
        if (isVertical) return 'top';
        return isRightToLeft ? 'right' : 'left';
    }
    function getEndEdge() {
        if (isVertical) return 'bottom';
        return isRightToLeft ? 'left' : 'right';
    }
    function direction(n) {
        return n * sign;
    }
    const self = {
        scroll: scroll,
        cross: cross,
        startEdge: startEdge,
        endEdge: endEdge,
        measureSize: measureSize,
        direction: direction
    };
    return self;
}
function $d65d5652050191ad$var$Limit(min = 0, max = 0) {
    const length = $d65d5652050191ad$var$mathAbs(min - max);
    function reachedMin(n) {
        return n < min;
    }
    function reachedMax(n) {
        return n > max;
    }
    function reachedAny(n) {
        return reachedMin(n) || reachedMax(n);
    }
    function constrain(n) {
        if (!reachedAny(n)) return n;
        return reachedMin(n) ? min : max;
    }
    function removeOffset(n) {
        if (!length) return n;
        return n - length * Math.ceil((n - max) / length);
    }
    const self = {
        length: length,
        max: max,
        min: min,
        constrain: constrain,
        reachedAny: reachedAny,
        reachedMax: reachedMax,
        reachedMin: reachedMin,
        removeOffset: removeOffset
    };
    return self;
}
function $d65d5652050191ad$var$Counter(max, start, loop) {
    const { constrain: constrain } = $d65d5652050191ad$var$Limit(0, max);
    const loopEnd = max + 1;
    let counter = withinLimit(start);
    function withinLimit(n) {
        return !loop ? constrain(n) : $d65d5652050191ad$var$mathAbs((loopEnd + n) % loopEnd);
    }
    function get() {
        return counter;
    }
    function set(n) {
        counter = withinLimit(n);
        return self;
    }
    function add(n) {
        return clone().set(get() + n);
    }
    function clone() {
        return $d65d5652050191ad$var$Counter(max, get(), loop);
    }
    const self = {
        get: get,
        set: set,
        add: add,
        clone: clone
    };
    return self;
}
function $d65d5652050191ad$var$DragHandler(axis, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
    const { cross: crossAxis, direction: direction } = axis;
    const focusNodes = [
        'INPUT',
        'SELECT',
        'TEXTAREA'
    ];
    const nonPassiveEvent = {
        passive: false
    };
    const initEvents = $d65d5652050191ad$var$EventStore();
    const dragEvents = $d65d5652050191ad$var$EventStore();
    const goToNextThreshold = $d65d5652050191ad$var$Limit(50, 225).constrain(percentOfView.measure(20));
    const snapForceBoost = {
        mouse: 300,
        touch: 400
    };
    const freeForceBoost = {
        mouse: 500,
        touch: 600
    };
    const baseSpeed = dragFree ? 43 : 25;
    let isMoving = false;
    let startScroll = 0;
    let startCross = 0;
    let pointerIsDown = false;
    let preventScroll = false;
    let preventClick = false;
    let isMouse = false;
    function init(emblaApi) {
        if (!watchDrag) return;
        function downIfAllowed(evt) {
            if ($d65d5652050191ad$var$isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
        }
        const node = rootNode;
        initEvents.add(node, 'dragstart', (evt)=>evt.preventDefault(), nonPassiveEvent).add(node, 'touchmove', ()=>undefined, nonPassiveEvent).add(node, 'touchend', ()=>undefined).add(node, 'touchstart', downIfAllowed).add(node, 'mousedown', downIfAllowed).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click, true);
    }
    function destroy() {
        initEvents.clear();
        dragEvents.clear();
    }
    function addDragEvents() {
        const node = isMouse ? ownerDocument : rootNode;
        dragEvents.add(node, 'touchmove', move, nonPassiveEvent).add(node, 'touchend', up).add(node, 'mousemove', move, nonPassiveEvent).add(node, 'mouseup', up);
    }
    function isFocusNode(node) {
        const nodeName = node.nodeName || '';
        return focusNodes.includes(nodeName);
    }
    function forceBoost() {
        const boost = dragFree ? freeForceBoost : snapForceBoost;
        const type = isMouse ? 'mouse' : 'touch';
        return boost[type];
    }
    function allowedForce(force, targetChanged) {
        const next = index.add($d65d5652050191ad$var$mathSign(force) * -1);
        const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
        if (dragFree || $d65d5652050191ad$var$mathAbs(force) < goToNextThreshold) return baseForce;
        if (skipSnaps && targetChanged) return baseForce * 0.5;
        return scrollTarget.byIndex(next.get(), 0).distance;
    }
    function down(evt) {
        const isMouseEvt = $d65d5652050191ad$var$isMouseEvent(evt, ownerWindow);
        isMouse = isMouseEvt;
        preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
        isMoving = $d65d5652050191ad$var$deltaAbs(target.get(), location.get()) >= 2;
        if (isMouseEvt && evt.button !== 0) return;
        if (isFocusNode(evt.target)) return;
        pointerIsDown = true;
        dragTracker.pointerDown(evt);
        scrollBody.useFriction(0).useDuration(0);
        target.set(location);
        addDragEvents();
        startScroll = dragTracker.readPoint(evt);
        startCross = dragTracker.readPoint(evt, crossAxis);
        eventHandler.emit('pointerDown');
    }
    function move(evt) {
        const isTouchEvt = !$d65d5652050191ad$var$isMouseEvent(evt, ownerWindow);
        if (isTouchEvt && evt.touches.length >= 2) return up(evt);
        const lastScroll = dragTracker.readPoint(evt);
        const lastCross = dragTracker.readPoint(evt, crossAxis);
        const diffScroll = $d65d5652050191ad$var$deltaAbs(lastScroll, startScroll);
        const diffCross = $d65d5652050191ad$var$deltaAbs(lastCross, startCross);
        if (!preventScroll && !isMouse) {
            if (!evt.cancelable) return up(evt);
            preventScroll = diffScroll > diffCross;
            if (!preventScroll) return up(evt);
        }
        const diff = dragTracker.pointerMove(evt);
        if (diffScroll > dragThreshold) preventClick = true;
        scrollBody.useFriction(0.3).useDuration(1);
        animation.start();
        target.add(direction(diff));
        evt.preventDefault();
    }
    function up(evt) {
        const currentLocation = scrollTarget.byDistance(0, false);
        const targetChanged = currentLocation.index !== index.get();
        const rawForce = dragTracker.pointerUp(evt) * forceBoost();
        const force = allowedForce(direction(rawForce), targetChanged);
        const forceFactor = $d65d5652050191ad$var$factorAbs(rawForce, force);
        const speed = baseSpeed - 10 * forceFactor;
        const friction = baseFriction + forceFactor / 50;
        preventScroll = false;
        pointerIsDown = false;
        dragEvents.clear();
        scrollBody.useDuration(speed).useFriction(friction);
        scrollTo.distance(force, !dragFree);
        isMouse = false;
        eventHandler.emit('pointerUp');
    }
    function click(evt) {
        if (preventClick) {
            evt.stopPropagation();
            evt.preventDefault();
            preventClick = false;
        }
    }
    function pointerDown() {
        return pointerIsDown;
    }
    const self = {
        init: init,
        pointerDown: pointerDown,
        destroy: destroy
    };
    return self;
}
function $d65d5652050191ad$var$DragTracker(axis, ownerWindow) {
    const logInterval = 170;
    let startEvent;
    let lastEvent;
    function readTime(evt) {
        return evt.timeStamp;
    }
    function readPoint(evt, evtAxis) {
        const property = evtAxis || axis.scroll;
        const coord = `client${property === 'x' ? 'X' : 'Y'}`;
        return ($d65d5652050191ad$var$isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
    }
    function pointerDown(evt) {
        startEvent = evt;
        lastEvent = evt;
        return readPoint(evt);
    }
    function pointerMove(evt) {
        const diff = readPoint(evt) - readPoint(lastEvent);
        const expired = readTime(evt) - readTime(startEvent) > logInterval;
        lastEvent = evt;
        if (expired) startEvent = evt;
        return diff;
    }
    function pointerUp(evt) {
        if (!startEvent || !lastEvent) return 0;
        const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
        const diffTime = readTime(evt) - readTime(startEvent);
        const expired = readTime(evt) - readTime(lastEvent) > logInterval;
        const force = diffDrag / diffTime;
        const isFlick = diffTime && !expired && $d65d5652050191ad$var$mathAbs(force) > 0.1;
        return isFlick ? force : 0;
    }
    const self = {
        pointerDown: pointerDown,
        pointerMove: pointerMove,
        pointerUp: pointerUp,
        readPoint: readPoint
    };
    return self;
}
function $d65d5652050191ad$var$NodeRects() {
    function measure(node) {
        const { offsetTop: offsetTop, offsetLeft: offsetLeft, offsetWidth: offsetWidth, offsetHeight: offsetHeight } = node;
        const offset = {
            top: offsetTop,
            right: offsetLeft + offsetWidth,
            bottom: offsetTop + offsetHeight,
            left: offsetLeft,
            width: offsetWidth,
            height: offsetHeight
        };
        return offset;
    }
    const self = {
        measure: measure
    };
    return self;
}
function $d65d5652050191ad$var$PercentOfView(viewSize) {
    function measure(n) {
        return viewSize * (n / 100);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $d65d5652050191ad$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
    let resizeObserver;
    let containerSize;
    let slideSizes = [];
    let destroyed = false;
    function readSize(node) {
        return axis.measureSize(nodeRects.measure(node));
    }
    function init(emblaApi) {
        if (!watchResize) return;
        containerSize = readSize(container);
        slideSizes = slides.map(readSize);
        function defaultCallback(entries) {
            for (const entry of entries){
                const isContainer = entry.target === container;
                const slideIndex = slides.indexOf(entry.target);
                const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
                const newSize = readSize(isContainer ? container : slides[slideIndex]);
                const diffSize = $d65d5652050191ad$var$mathAbs(newSize - lastSize);
                if (diffSize >= 0.5) {
                    ownerWindow.requestAnimationFrame(()=>{
                        emblaApi.reInit();
                        eventHandler.emit('resize');
                    });
                    break;
                }
            }
        }
        resizeObserver = new ResizeObserver((entries)=>{
            if (destroyed) return;
            if ($d65d5652050191ad$var$isBoolean(watchResize) || watchResize(emblaApi, entries)) defaultCallback(entries);
        });
        const observeNodes = [
            container
        ].concat(slides);
        observeNodes.forEach((node)=>resizeObserver.observe(node));
    }
    function destroy() {
        if (resizeObserver) resizeObserver.disconnect();
        destroyed = true;
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $d65d5652050191ad$var$ScrollBody(location, offsetLocation, target, baseDuration, baseFriction) {
    let bodyVelocity = 0;
    let scrollDirection = 0;
    let scrollDuration = baseDuration;
    let scrollFriction = baseFriction;
    let rawLocation = location.get();
    let rawLocationPrevious = 0;
    function seek() {
        const diff = target.get() - location.get();
        const isInstant = !scrollDuration;
        let directionDiff = 0;
        if (isInstant) {
            bodyVelocity = 0;
            location.set(target);
            directionDiff = diff;
        } else {
            bodyVelocity += diff / scrollDuration;
            bodyVelocity *= scrollFriction;
            rawLocation += bodyVelocity;
            location.add(bodyVelocity);
            directionDiff = rawLocation - rawLocationPrevious;
        }
        scrollDirection = $d65d5652050191ad$var$mathSign(directionDiff);
        rawLocationPrevious = rawLocation;
        return self;
    }
    function settled() {
        const diff = target.get() - offsetLocation.get();
        return $d65d5652050191ad$var$mathAbs(diff) < 0.001;
    }
    function duration() {
        return scrollDuration;
    }
    function direction() {
        return scrollDirection;
    }
    function velocity() {
        return bodyVelocity;
    }
    function useBaseDuration() {
        return useDuration(baseDuration);
    }
    function useBaseFriction() {
        return useFriction(baseFriction);
    }
    function useDuration(n) {
        scrollDuration = n;
        return self;
    }
    function useFriction(n) {
        scrollFriction = n;
        return self;
    }
    const self = {
        direction: direction,
        duration: duration,
        velocity: velocity,
        seek: seek,
        settled: settled,
        useBaseFriction: useBaseFriction,
        useBaseDuration: useBaseDuration,
        useFriction: useFriction,
        useDuration: useDuration
    };
    return self;
}
function $d65d5652050191ad$var$ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView) {
    const pullBackThreshold = percentOfView.measure(10);
    const edgeOffsetTolerance = percentOfView.measure(50);
    const frictionLimit = $d65d5652050191ad$var$Limit(0.1, 0.99);
    let disabled = false;
    function shouldConstrain() {
        if (disabled) return false;
        if (!limit.reachedAny(target.get())) return false;
        if (!limit.reachedAny(offsetLocation.get())) return false;
        return true;
    }
    function constrain(pointerDown) {
        if (!shouldConstrain()) return;
        const edge = limit.reachedMin(offsetLocation.get()) ? 'min' : 'max';
        const diffToEdge = $d65d5652050191ad$var$mathAbs(limit[edge] - offsetLocation.get());
        const diffToTarget = target.get() - offsetLocation.get();
        const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
        target.subtract(diffToTarget * friction);
        if (!pointerDown && $d65d5652050191ad$var$mathAbs(diffToTarget) < pullBackThreshold) {
            target.set(limit.constrain(target.get()));
            scrollBody.useDuration(25).useBaseFriction();
        }
    }
    function toggleActive(active) {
        disabled = !active;
    }
    const self = {
        constrain: constrain,
        toggleActive: toggleActive
    };
    return self;
}
function $d65d5652050191ad$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
    const scrollBounds = $d65d5652050191ad$var$Limit(-contentSize + viewSize, 0);
    const snapsBounded = measureBounded();
    const scrollContainLimit = findScrollContainLimit();
    const snapsContained = measureContained();
    function usePixelTolerance(bound, snap) {
        return $d65d5652050191ad$var$deltaAbs(bound, snap) < 1;
    }
    function findScrollContainLimit() {
        const startSnap = snapsBounded[0];
        const endSnap = $d65d5652050191ad$var$arrayLast(snapsBounded);
        const min = snapsBounded.lastIndexOf(startSnap);
        const max = snapsBounded.indexOf(endSnap) + 1;
        return $d65d5652050191ad$var$Limit(min, max);
    }
    function measureBounded() {
        return snapsAligned.map((snapAligned, index)=>{
            const { min: min, max: max } = scrollBounds;
            const snap = scrollBounds.constrain(snapAligned);
            const isFirst = !index;
            const isLast = $d65d5652050191ad$var$arrayIsLastIndex(snapsAligned, index);
            if (isFirst) return max;
            if (isLast) return min;
            if (usePixelTolerance(min, snap)) return min;
            if (usePixelTolerance(max, snap)) return max;
            return snap;
        }).map((scrollBound)=>parseFloat(scrollBound.toFixed(3)));
    }
    function measureContained() {
        if (contentSize <= viewSize + pixelTolerance) return [
            scrollBounds.max
        ];
        if (containScroll === 'keepSnaps') return snapsBounded;
        const { min: min, max: max } = scrollContainLimit;
        return snapsBounded.slice(min, max);
    }
    const self = {
        snapsContained: snapsContained,
        scrollContainLimit: scrollContainLimit
    };
    return self;
}
function $d65d5652050191ad$var$ScrollLimit(contentSize, scrollSnaps, loop) {
    const max = scrollSnaps[0];
    const min = loop ? max - contentSize : $d65d5652050191ad$var$arrayLast(scrollSnaps);
    const limit = $d65d5652050191ad$var$Limit(min, max);
    const self = {
        limit: limit
    };
    return self;
}
function $d65d5652050191ad$var$ScrollLooper(contentSize, limit, offsetLocation, vectors) {
    const jointSafety = 0.1;
    const min = limit.min + jointSafety;
    const max = limit.max + jointSafety;
    const { reachedMin: reachedMin, reachedMax: reachedMax } = $d65d5652050191ad$var$Limit(min, max);
    function shouldLoop(direction) {
        if (direction === 1) return reachedMax(offsetLocation.get());
        if (direction === -1) return reachedMin(offsetLocation.get());
        return false;
    }
    function loop(direction) {
        if (!shouldLoop(direction)) return;
        const loopDistance = contentSize * (direction * -1);
        vectors.forEach((v)=>v.add(loopDistance));
    }
    const self = {
        loop: loop
    };
    return self;
}
function $d65d5652050191ad$var$ScrollProgress(limit) {
    const { max: max, length: length } = limit;
    function get(n) {
        const currentLocation = n - max;
        return length ? currentLocation / -length : 0;
    }
    const self = {
        get: get
    };
    return self;
}
function $d65d5652050191ad$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
    const { startEdge: startEdge, endEdge: endEdge } = axis;
    const { groupSlides: groupSlides } = slidesToScroll;
    const alignments = measureSizes().map(alignment.measure);
    const snaps = measureUnaligned();
    const snapsAligned = measureAligned();
    function measureSizes() {
        return groupSlides(slideRects).map((rects)=>$d65d5652050191ad$var$arrayLast(rects)[endEdge] - rects[0][startEdge]).map($d65d5652050191ad$var$mathAbs);
    }
    function measureUnaligned() {
        return slideRects.map((rect)=>containerRect[startEdge] - rect[startEdge]).map((snap)=>-$d65d5652050191ad$var$mathAbs(snap));
    }
    function measureAligned() {
        return groupSlides(snaps).map((g)=>g[0]).map((snap, index)=>snap + alignments[index]);
    }
    const self = {
        snaps: snaps,
        snapsAligned: snapsAligned
    };
    return self;
}
function $d65d5652050191ad$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
    const { groupSlides: groupSlides } = slidesToScroll;
    const { min: min, max: max } = scrollContainLimit;
    const slideRegistry = createSlideRegistry();
    function createSlideRegistry() {
        const groupedSlideIndexes = groupSlides(slideIndexes);
        const doNotContain = !containSnaps || containScroll === 'keepSnaps';
        if (scrollSnaps.length === 1) return [
            slideIndexes
        ];
        if (doNotContain) return groupedSlideIndexes;
        return groupedSlideIndexes.slice(min, max).map((group, index, groups)=>{
            const isFirst = !index;
            const isLast = $d65d5652050191ad$var$arrayIsLastIndex(groups, index);
            if (isFirst) {
                const range = $d65d5652050191ad$var$arrayLast(groups[0]) + 1;
                return $d65d5652050191ad$var$arrayFromNumber(range);
            }
            if (isLast) {
                const range = $d65d5652050191ad$var$arrayLastIndex(slideIndexes) - $d65d5652050191ad$var$arrayLast(groups)[0] + 1;
                return $d65d5652050191ad$var$arrayFromNumber(range, $d65d5652050191ad$var$arrayLast(groups)[0]);
            }
            return group;
        });
    }
    const self = {
        slideRegistry: slideRegistry
    };
    return self;
}
function $d65d5652050191ad$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
    const { reachedAny: reachedAny, removeOffset: removeOffset, constrain: constrain } = limit;
    function minDistance(distances) {
        return distances.concat().sort((a, b)=>$d65d5652050191ad$var$mathAbs(a) - $d65d5652050191ad$var$mathAbs(b))[0];
    }
    function findTargetSnap(target) {
        const distance = loop ? removeOffset(target) : constrain(target);
        const ascDiffsToSnaps = scrollSnaps.map((snap, index)=>({
                diff: shortcut(snap - distance, 0),
                index: index
            })).sort((d1, d2)=>$d65d5652050191ad$var$mathAbs(d1.diff) - $d65d5652050191ad$var$mathAbs(d2.diff));
        const { index: index } = ascDiffsToSnaps[0];
        return {
            index: index,
            distance: distance
        };
    }
    function shortcut(target, direction) {
        const targets = [
            target,
            target + contentSize,
            target - contentSize
        ];
        if (!loop) return targets[0];
        if (!direction) return minDistance(targets);
        const matchingTargets = targets.filter((t)=>$d65d5652050191ad$var$mathSign(t) === direction);
        if (matchingTargets.length) return minDistance(matchingTargets);
        return $d65d5652050191ad$var$arrayLast(targets) - contentSize;
    }
    function byIndex(index, direction) {
        const diffToSnap = scrollSnaps[index] - targetVector.get();
        const distance = shortcut(diffToSnap, direction);
        return {
            index: index,
            distance: distance
        };
    }
    function byDistance(distance, snap) {
        const target = targetVector.get() + distance;
        const { index: index, distance: targetSnapDistance } = findTargetSnap(target);
        const reachedBound = !loop && reachedAny(target);
        if (!snap || reachedBound) return {
            index: index,
            distance: distance
        };
        const diffToSnap = scrollSnaps[index] - targetSnapDistance;
        const snapDistance = distance + shortcut(diffToSnap, 0);
        return {
            index: index,
            distance: snapDistance
        };
    }
    const self = {
        byDistance: byDistance,
        byIndex: byIndex,
        shortcut: shortcut
    };
    return self;
}
function $d65d5652050191ad$var$ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
    function scrollTo(target) {
        const distanceDiff = target.distance;
        const indexDiff = target.index !== indexCurrent.get();
        targetVector.add(distanceDiff);
        if (distanceDiff) {
            if (scrollBody.duration()) animation.start();
            else {
                animation.update();
                animation.render(1);
                animation.update();
            }
        }
        if (indexDiff) {
            indexPrevious.set(indexCurrent.get());
            indexCurrent.set(target.index);
            eventHandler.emit('select');
        }
    }
    function distance(n, snap) {
        const target = scrollTarget.byDistance(n, snap);
        scrollTo(target);
    }
    function index(n, direction) {
        const targetIndex = indexCurrent.clone().set(n);
        const target = scrollTarget.byIndex(targetIndex.get(), direction);
        scrollTo(target);
    }
    const self = {
        distance: distance,
        index: index
    };
    return self;
}
function $d65d5652050191ad$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore) {
    let lastTabPressTime = 0;
    function init() {
        eventStore.add(document, 'keydown', registerTabPress, false);
        slides.forEach(addSlideFocusEvent);
    }
    function registerTabPress(event) {
        if (event.code === 'Tab') lastTabPressTime = new Date().getTime();
    }
    function addSlideFocusEvent(slide) {
        const focus = ()=>{
            const nowTime = new Date().getTime();
            const diffTime = nowTime - lastTabPressTime;
            if (diffTime > 10) return;
            root.scrollLeft = 0;
            const index = slides.indexOf(slide);
            const group = slideRegistry.findIndex((group)=>group.includes(index));
            if (!$d65d5652050191ad$var$isNumber(group)) return;
            scrollBody.useDuration(0);
            scrollTo.index(group, 0);
        };
        eventStore.add(slide, 'focus', focus, {
            passive: true,
            capture: true
        });
    }
    const self = {
        init: init
    };
    return self;
}
function $d65d5652050191ad$var$Vector1D(initialValue) {
    let value = initialValue;
    function get() {
        return value;
    }
    function set(n) {
        value = normalizeInput(n);
    }
    function add(n) {
        value += normalizeInput(n);
    }
    function subtract(n) {
        value -= normalizeInput(n);
    }
    function normalizeInput(n) {
        return $d65d5652050191ad$var$isNumber(n) ? n : n.get();
    }
    const self = {
        get: get,
        set: set,
        add: add,
        subtract: subtract
    };
    return self;
}
function $d65d5652050191ad$var$Translate(axis, container) {
    const translate = axis.scroll === 'x' ? x : y;
    const containerStyle = container.style;
    let disabled = false;
    function x(n) {
        return `translate3d(${n}px,0px,0px)`;
    }
    function y(n) {
        return `translate3d(0px,${n}px,0px)`;
    }
    function to(target) {
        if (disabled) return;
        containerStyle.transform = translate(axis.direction(target));
    }
    function toggleActive(active) {
        disabled = !active;
    }
    function clear() {
        if (disabled) return;
        containerStyle.transform = '';
        if (!container.getAttribute('style')) container.removeAttribute('style');
    }
    const self = {
        clear: clear,
        to: to,
        toggleActive: toggleActive
    };
    return self;
}
function $d65d5652050191ad$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides) {
    const roundingSafety = 0.5;
    const ascItems = $d65d5652050191ad$var$arrayKeys(slideSizesWithGaps);
    const descItems = $d65d5652050191ad$var$arrayKeys(slideSizesWithGaps).reverse();
    const loopPoints = startPoints().concat(endPoints());
    function removeSlideSizes(indexes, from) {
        return indexes.reduce((a, i)=>{
            return a - slideSizesWithGaps[i];
        }, from);
    }
    function slidesInGap(indexes, gap) {
        return indexes.reduce((a, i)=>{
            const remainingGap = removeSlideSizes(a, gap);
            return remainingGap > 0 ? a.concat([
                i
            ]) : a;
        }, []);
    }
    function findSlideBounds(offset) {
        return snaps.map((snap, index)=>({
                start: snap - slideSizes[index] + roundingSafety + offset,
                end: snap + viewSize - roundingSafety + offset
            }));
    }
    function findLoopPoints(indexes, offset, isEndEdge) {
        const slideBounds = findSlideBounds(offset);
        return indexes.map((index)=>{
            const initial = isEndEdge ? 0 : -contentSize;
            const altered = isEndEdge ? contentSize : 0;
            const boundEdge = isEndEdge ? 'end' : 'start';
            const loopPoint = slideBounds[index][boundEdge];
            return {
                index: index,
                loopPoint: loopPoint,
                slideLocation: $d65d5652050191ad$var$Vector1D(-1),
                translate: $d65d5652050191ad$var$Translate(axis, slides[index]),
                target: ()=>offsetLocation.get() > loopPoint ? initial : altered
            };
        });
    }
    function startPoints() {
        const gap = scrollSnaps[0];
        const indexes = slidesInGap(descItems, gap);
        return findLoopPoints(indexes, contentSize, false);
    }
    function endPoints() {
        const gap = viewSize - scrollSnaps[0] - 1;
        const indexes = slidesInGap(ascItems, gap);
        return findLoopPoints(indexes, -contentSize, true);
    }
    function canLoop() {
        return loopPoints.every(({ index: index })=>{
            const otherIndexes = ascItems.filter((i)=>i !== index);
            return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
        });
    }
    function loop() {
        loopPoints.forEach((loopPoint)=>{
            const { target: target, translate: translate, slideLocation: slideLocation } = loopPoint;
            const shiftLocation = target();
            if (shiftLocation === slideLocation.get()) return;
            translate.to(shiftLocation);
            slideLocation.set(shiftLocation);
        });
    }
    function clear() {
        loopPoints.forEach((loopPoint)=>loopPoint.translate.clear());
    }
    const self = {
        canLoop: canLoop,
        clear: clear,
        loop: loop,
        loopPoints: loopPoints
    };
    return self;
}
function $d65d5652050191ad$var$SlidesHandler(container, eventHandler, watchSlides) {
    let mutationObserver;
    let destroyed = false;
    function init(emblaApi) {
        if (!watchSlides) return;
        function defaultCallback(mutations) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                emblaApi.reInit();
                eventHandler.emit('slidesChanged');
                break;
            }
        }
        mutationObserver = new MutationObserver((mutations)=>{
            if (destroyed) return;
            if ($d65d5652050191ad$var$isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) defaultCallback(mutations);
        });
        mutationObserver.observe(container, {
            childList: true
        });
    }
    function destroy() {
        if (mutationObserver) mutationObserver.disconnect();
        destroyed = true;
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $d65d5652050191ad$var$SlidesInView(container, slides, eventHandler, threshold) {
    const intersectionEntryMap = {};
    let inViewCache = null;
    let notInViewCache = null;
    let intersectionObserver;
    let destroyed = false;
    function init() {
        intersectionObserver = new IntersectionObserver((entries)=>{
            if (destroyed) return;
            entries.forEach((entry)=>{
                const index = slides.indexOf(entry.target);
                intersectionEntryMap[index] = entry;
            });
            inViewCache = null;
            notInViewCache = null;
            eventHandler.emit('slidesInView');
        }, {
            root: container.parentElement,
            threshold: threshold
        });
        slides.forEach((slide)=>intersectionObserver.observe(slide));
    }
    function destroy() {
        if (intersectionObserver) intersectionObserver.disconnect();
        destroyed = true;
    }
    function createInViewList(inView) {
        return $d65d5652050191ad$var$objectKeys(intersectionEntryMap).reduce((list, slideIndex)=>{
            const index = parseInt(slideIndex);
            const { isIntersecting: isIntersecting } = intersectionEntryMap[index];
            const inViewMatch = inView && isIntersecting;
            const notInViewMatch = !inView && !isIntersecting;
            if (inViewMatch || notInViewMatch) list.push(index);
            return list;
        }, []);
    }
    function get(inView = true) {
        if (inView && inViewCache) return inViewCache;
        if (!inView && notInViewCache) return notInViewCache;
        const slideIndexes = createInViewList(inView);
        if (inView) inViewCache = slideIndexes;
        if (!inView) notInViewCache = slideIndexes;
        return slideIndexes;
    }
    const self = {
        init: init,
        destroy: destroy,
        get: get
    };
    return self;
}
function $d65d5652050191ad$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
    const { measureSize: measureSize, startEdge: startEdge, endEdge: endEdge } = axis;
    const withEdgeGap = slideRects[0] && readEdgeGap;
    const startGap = measureStartGap();
    const endGap = measureEndGap();
    const slideSizes = slideRects.map(measureSize);
    const slideSizesWithGaps = measureWithGaps();
    function measureStartGap() {
        if (!withEdgeGap) return 0;
        const slideRect = slideRects[0];
        return $d65d5652050191ad$var$mathAbs(containerRect[startEdge] - slideRect[startEdge]);
    }
    function measureEndGap() {
        if (!withEdgeGap) return 0;
        const style = ownerWindow.getComputedStyle($d65d5652050191ad$var$arrayLast(slides));
        return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
    }
    function measureWithGaps() {
        return slideRects.map((rect, index, rects)=>{
            const isFirst = !index;
            const isLast = $d65d5652050191ad$var$arrayIsLastIndex(rects, index);
            if (isFirst) return slideSizes[index] + startGap;
            if (isLast) return slideSizes[index] + endGap;
            return rects[index + 1][startEdge] - rect[startEdge];
        }).map($d65d5652050191ad$var$mathAbs);
    }
    const self = {
        slideSizes: slideSizes,
        slideSizesWithGaps: slideSizesWithGaps,
        startGap: startGap,
        endGap: endGap
    };
    return self;
}
function $d65d5652050191ad$var$SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
    const { startEdge: startEdge, endEdge: endEdge, direction: direction } = axis;
    const groupByNumber = $d65d5652050191ad$var$isNumber(slidesToScroll);
    function byNumber(array, groupSize) {
        return $d65d5652050191ad$var$arrayKeys(array).filter((i)=>i % groupSize === 0).map((i)=>array.slice(i, i + groupSize));
    }
    function bySize(array) {
        if (!array.length) return [];
        return $d65d5652050191ad$var$arrayKeys(array).reduce((groups, rectB, index)=>{
            const rectA = $d65d5652050191ad$var$arrayLast(groups) || 0;
            const isFirst = rectA === 0;
            const isLast = rectB === $d65d5652050191ad$var$arrayLastIndex(array);
            const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
            const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
            const gapA = !loop && isFirst ? direction(startGap) : 0;
            const gapB = !loop && isLast ? direction(endGap) : 0;
            const chunkSize = $d65d5652050191ad$var$mathAbs(edgeB - gapB - (edgeA + gapA));
            if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
            if (isLast) groups.push(array.length);
            return groups;
        }, []).map((currentSize, index, groups)=>{
            const previousSize = Math.max(groups[index - 1] || 0);
            return array.slice(previousSize, currentSize);
        });
    }
    function groupSlides(array) {
        return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
    }
    const self = {
        groupSlides: groupSlides
    };
    return self;
}
function $d65d5652050191ad$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
    // Options
    const { align: align, axis: scrollAxis, direction: direction, startIndex: startIndex, loop: loop, duration: duration, dragFree: dragFree, dragThreshold: dragThreshold, inViewThreshold: inViewThreshold, slidesToScroll: groupSlides, skipSnaps: skipSnaps, containScroll: containScroll, watchResize: watchResize, watchSlides: watchSlides, watchDrag: watchDrag } = options;
    // Measurements
    const pixelTolerance = 2;
    const nodeRects = $d65d5652050191ad$var$NodeRects();
    const containerRect = nodeRects.measure(container);
    const slideRects = slides.map(nodeRects.measure);
    const axis = $d65d5652050191ad$var$Axis(scrollAxis, direction);
    const viewSize = axis.measureSize(containerRect);
    const percentOfView = $d65d5652050191ad$var$PercentOfView(viewSize);
    const alignment = $d65d5652050191ad$var$Alignment(align, viewSize);
    const containSnaps = !loop && !!containScroll;
    const readEdgeGap = loop || !!containScroll;
    const { slideSizes: slideSizes, slideSizesWithGaps: slideSizesWithGaps, startGap: startGap, endGap: endGap } = $d65d5652050191ad$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
    const slidesToScroll = $d65d5652050191ad$var$SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
    const { snaps: snaps, snapsAligned: snapsAligned } = $d65d5652050191ad$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
    const contentSize = -$d65d5652050191ad$var$arrayLast(snaps) + $d65d5652050191ad$var$arrayLast(slideSizesWithGaps);
    const { snapsContained: snapsContained, scrollContainLimit: scrollContainLimit } = $d65d5652050191ad$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
    const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
    const { limit: limit } = $d65d5652050191ad$var$ScrollLimit(contentSize, scrollSnaps, loop);
    // Indexes
    const index = $d65d5652050191ad$var$Counter($d65d5652050191ad$var$arrayLastIndex(scrollSnaps), startIndex, loop);
    const indexPrevious = index.clone();
    const slideIndexes = $d65d5652050191ad$var$arrayKeys(slides);
    // Animation
    const update = ({ dragHandler: dragHandler, scrollBody: scrollBody, scrollBounds: scrollBounds, options: { loop: loop } })=>{
        if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
        scrollBody.seek();
    };
    const render = ({ scrollBody: scrollBody, translate: translate, location: location, offsetLocation: offsetLocation, scrollLooper: scrollLooper, slideLooper: slideLooper, dragHandler: dragHandler, animation: animation, eventHandler: eventHandler, options: { loop: loop } }, lagOffset)=>{
        const velocity = scrollBody.velocity();
        const hasSettled = scrollBody.settled();
        if (hasSettled && !dragHandler.pointerDown()) {
            animation.stop();
            eventHandler.emit('settle');
        }
        if (!hasSettled) eventHandler.emit('scroll');
        offsetLocation.set(location.get() - velocity + velocity * lagOffset);
        if (loop) {
            scrollLooper.loop(scrollBody.direction());
            slideLooper.loop();
        }
        translate.to(offsetLocation.get());
    };
    const animation = $d65d5652050191ad$var$Animations(ownerDocument, ownerWindow, ()=>update(engine), (lagOffset)=>render(engine, lagOffset));
    // Shared
    const friction = 0.68;
    const startLocation = scrollSnaps[index.get()];
    const location = $d65d5652050191ad$var$Vector1D(startLocation);
    const offsetLocation = $d65d5652050191ad$var$Vector1D(startLocation);
    const target = $d65d5652050191ad$var$Vector1D(startLocation);
    const scrollBody = $d65d5652050191ad$var$ScrollBody(location, offsetLocation, target, duration, friction);
    const scrollTarget = $d65d5652050191ad$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
    const scrollTo = $d65d5652050191ad$var$ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
    const scrollProgress = $d65d5652050191ad$var$ScrollProgress(limit);
    const eventStore = $d65d5652050191ad$var$EventStore();
    const slidesInView = $d65d5652050191ad$var$SlidesInView(container, slides, eventHandler, inViewThreshold);
    const { slideRegistry: slideRegistry } = $d65d5652050191ad$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
    const slideFocus = $d65d5652050191ad$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore);
    // Engine
    const engine = {
        ownerDocument: ownerDocument,
        ownerWindow: ownerWindow,
        eventHandler: eventHandler,
        containerRect: containerRect,
        slideRects: slideRects,
        animation: animation,
        axis: axis,
        dragHandler: $d65d5652050191ad$var$DragHandler(axis, root, ownerDocument, ownerWindow, target, $d65d5652050191ad$var$DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
        eventStore: eventStore,
        percentOfView: percentOfView,
        index: index,
        indexPrevious: indexPrevious,
        limit: limit,
        location: location,
        offsetLocation: offsetLocation,
        options: options,
        resizeHandler: $d65d5652050191ad$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
        scrollBody: scrollBody,
        scrollBounds: $d65d5652050191ad$var$ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
        scrollLooper: $d65d5652050191ad$var$ScrollLooper(contentSize, limit, offsetLocation, [
            location,
            offsetLocation,
            target
        ]),
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnaps.map(scrollProgress.get),
        scrollSnaps: scrollSnaps,
        scrollTarget: scrollTarget,
        scrollTo: scrollTo,
        slideLooper: $d65d5652050191ad$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
        slideFocus: slideFocus,
        slidesHandler: $d65d5652050191ad$var$SlidesHandler(container, eventHandler, watchSlides),
        slidesInView: slidesInView,
        slideIndexes: slideIndexes,
        slideRegistry: slideRegistry,
        slidesToScroll: slidesToScroll,
        target: target,
        translate: $d65d5652050191ad$var$Translate(axis, container)
    };
    return engine;
}
function $d65d5652050191ad$var$EventHandler() {
    const listeners = {};
    let api;
    function init(emblaApi) {
        api = emblaApi;
    }
    function getListeners(evt) {
        return listeners[evt] || [];
    }
    function emit(evt) {
        getListeners(evt).forEach((e)=>e(api, evt));
        return self;
    }
    function on(evt, cb) {
        listeners[evt] = getListeners(evt).concat([
            cb
        ]);
        return self;
    }
    function off(evt, cb) {
        listeners[evt] = getListeners(evt).filter((e)=>e !== cb);
        return self;
    }
    const self = {
        init: init,
        emit: emit,
        off: off,
        on: on
    };
    return self;
}
const $d65d5652050191ad$var$defaultOptions = {
    align: 'center',
    axis: 'x',
    container: null,
    slides: null,
    containScroll: 'trimSnaps',
    direction: 'ltr',
    slidesToScroll: 1,
    inViewThreshold: 0,
    breakpoints: {},
    dragFree: false,
    dragThreshold: 10,
    loop: false,
    skipSnaps: false,
    duration: 25,
    startIndex: 0,
    active: true,
    watchDrag: true,
    watchResize: true,
    watchSlides: true
};
function $d65d5652050191ad$var$OptionsHandler(ownerWindow) {
    function mergeOptions(optionsA, optionsB) {
        return $d65d5652050191ad$var$objectsMergeDeep(optionsA, optionsB || {});
    }
    function optionsAtMedia(options) {
        const optionsAtMedia = options.breakpoints || {};
        const matchedMediaOptions = $d65d5652050191ad$var$objectKeys(optionsAtMedia).filter((media)=>ownerWindow.matchMedia(media).matches).map((media)=>optionsAtMedia[media]).reduce((a, mediaOption)=>mergeOptions(a, mediaOption), {});
        return mergeOptions(options, matchedMediaOptions);
    }
    function optionsMediaQueries(optionsList) {
        return optionsList.map((options)=>$d65d5652050191ad$var$objectKeys(options.breakpoints || {})).reduce((acc, mediaQueries)=>acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
    }
    const self = {
        mergeOptions: mergeOptions,
        optionsAtMedia: optionsAtMedia,
        optionsMediaQueries: optionsMediaQueries
    };
    return self;
}
function $d65d5652050191ad$var$PluginsHandler(optionsHandler) {
    let activePlugins = [];
    function init(emblaApi, plugins) {
        activePlugins = plugins.filter(({ options: options })=>optionsHandler.optionsAtMedia(options).active !== false);
        activePlugins.forEach((plugin)=>plugin.init(emblaApi, optionsHandler));
        return plugins.reduce((map, plugin)=>Object.assign(map, {
                [plugin.name]: plugin
            }), {});
    }
    function destroy() {
        activePlugins = activePlugins.filter((plugin)=>plugin.destroy());
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $d65d5652050191ad$export$2e2bcd8739ae039(root, userOptions, userPlugins) {
    const ownerDocument = root.ownerDocument;
    const ownerWindow = ownerDocument.defaultView;
    const optionsHandler = $d65d5652050191ad$var$OptionsHandler(ownerWindow);
    const pluginsHandler = $d65d5652050191ad$var$PluginsHandler(optionsHandler);
    const mediaHandlers = $d65d5652050191ad$var$EventStore();
    const eventHandler = $d65d5652050191ad$var$EventHandler();
    const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia, optionsMediaQueries: optionsMediaQueries } = optionsHandler;
    const { on: on, off: off, emit: emit } = eventHandler;
    const reInit = reActivate;
    let destroyed = false;
    let engine;
    let optionsBase = mergeOptions($d65d5652050191ad$var$defaultOptions, $d65d5652050191ad$export$2e2bcd8739ae039.globalOptions);
    let options = mergeOptions(optionsBase);
    let pluginList = [];
    let pluginApis;
    let container;
    let slides;
    function storeElements() {
        const { container: userContainer, slides: userSlides } = options;
        const customContainer = $d65d5652050191ad$var$isString(userContainer) ? root.querySelector(userContainer) : userContainer;
        container = customContainer || root.children[0];
        const customSlides = $d65d5652050191ad$var$isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
        slides = [].slice.call(customSlides || container.children);
    }
    function createEngine(options) {
        const engine = $d65d5652050191ad$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
        if (options.loop && !engine.slideLooper.canLoop()) {
            const optionsWithoutLoop = Object.assign({}, options, {
                loop: false
            });
            return createEngine(optionsWithoutLoop);
        }
        return engine;
    }
    function activate(withOptions, withPlugins) {
        if (destroyed) return;
        optionsBase = mergeOptions(optionsBase, withOptions);
        options = optionsAtMedia(optionsBase);
        pluginList = withPlugins || pluginList;
        storeElements();
        engine = createEngine(options);
        optionsMediaQueries([
            optionsBase,
            ...pluginList.map(({ options: options })=>options)
        ]).forEach((query)=>mediaHandlers.add(query, 'change', reActivate));
        if (!options.active) return;
        engine.translate.to(engine.location.get());
        engine.animation.init();
        engine.slidesInView.init();
        engine.slideFocus.init();
        engine.eventHandler.init(self);
        engine.resizeHandler.init(self);
        engine.slidesHandler.init(self);
        if (engine.options.loop) engine.slideLooper.loop();
        if (container.offsetParent && slides.length) engine.dragHandler.init(self);
        pluginApis = pluginsHandler.init(self, pluginList);
    }
    function reActivate(withOptions, withPlugins) {
        const startIndex = selectedScrollSnap();
        deActivate();
        activate(mergeOptions({
            startIndex: startIndex
        }, withOptions), withPlugins);
        eventHandler.emit('reInit');
    }
    function deActivate() {
        engine.dragHandler.destroy();
        engine.eventStore.clear();
        engine.translate.clear();
        engine.slideLooper.clear();
        engine.resizeHandler.destroy();
        engine.slidesHandler.destroy();
        engine.slidesInView.destroy();
        engine.animation.destroy();
        pluginsHandler.destroy();
        mediaHandlers.clear();
    }
    function destroy() {
        if (destroyed) return;
        destroyed = true;
        mediaHandlers.clear();
        deActivate();
        eventHandler.emit('destroy');
    }
    function scrollTo(index, jump, direction) {
        if (!options.active || destroyed) return;
        engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
        engine.scrollTo.index(index, direction || 0);
    }
    function scrollNext(jump) {
        const next = engine.index.add(1).get();
        scrollTo(next, jump, -1);
    }
    function scrollPrev(jump) {
        const prev = engine.index.add(-1).get();
        scrollTo(prev, jump, 1);
    }
    function canScrollNext() {
        const next = engine.index.add(1).get();
        return next !== selectedScrollSnap();
    }
    function canScrollPrev() {
        const prev = engine.index.add(-1).get();
        return prev !== selectedScrollSnap();
    }
    function scrollSnapList() {
        return engine.scrollSnapList;
    }
    function scrollProgress() {
        return engine.scrollProgress.get(engine.location.get());
    }
    function selectedScrollSnap() {
        return engine.index.get();
    }
    function previousScrollSnap() {
        return engine.indexPrevious.get();
    }
    function slidesInView() {
        return engine.slidesInView.get();
    }
    function slidesNotInView() {
        return engine.slidesInView.get(false);
    }
    function plugins() {
        return pluginApis;
    }
    function internalEngine() {
        return engine;
    }
    function rootNode() {
        return root;
    }
    function containerNode() {
        return container;
    }
    function slideNodes() {
        return slides;
    }
    const self = {
        canScrollNext: canScrollNext,
        canScrollPrev: canScrollPrev,
        containerNode: containerNode,
        internalEngine: internalEngine,
        destroy: destroy,
        off: off,
        on: on,
        emit: emit,
        plugins: plugins,
        previousScrollSnap: previousScrollSnap,
        reInit: reInit,
        rootNode: rootNode,
        scrollNext: scrollNext,
        scrollPrev: scrollPrev,
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnapList,
        scrollTo: scrollTo,
        selectedScrollSnap: selectedScrollSnap,
        slideNodes: slideNodes,
        slidesInView: slidesInView,
        slidesNotInView: slidesNotInView
    };
    activate(userOptions, userPlugins);
    setTimeout(()=>eventHandler.emit('init'), 0);
    return self;
}
$d65d5652050191ad$export$2e2bcd8739ae039.globalOptions = undefined;


const $879e3510c4c2d8fa$var$defaultOptions = {
    active: true,
    breakpoints: {},
    delay: 4000,
    jump: false,
    playOnInit: true,
    stopOnFocusIn: true,
    stopOnInteraction: true,
    stopOnMouseEnter: false,
    stopOnLastSnap: false,
    rootNode: null
};
function $879e3510c4c2d8fa$export$2e2bcd8739ae039(userOptions = {}) {
    let options;
    let emblaApi;
    let destroyed;
    let playing = false;
    let resume = true;
    let jump = false;
    let timer = 0;
    function init(emblaApiInstance, optionsHandler) {
        emblaApi = emblaApiInstance;
        const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia } = optionsHandler;
        const optionsBase = mergeOptions($879e3510c4c2d8fa$var$defaultOptions, $879e3510c4c2d8fa$export$2e2bcd8739ae039.globalOptions);
        const allOptions = mergeOptions(optionsBase, userOptions);
        options = optionsAtMedia(allOptions);
        if (emblaApi.scrollSnapList().length <= 1) return;
        jump = options.jump;
        destroyed = false;
        const { eventStore: eventStore, ownerDocument: ownerDocument } = emblaApi.internalEngine();
        const emblaRoot = emblaApi.rootNode();
        const root = options.rootNode && options.rootNode(emblaRoot) || emblaRoot;
        const container = emblaApi.containerNode();
        emblaApi.on('pointerDown', stopTimer);
        if (!options.stopOnInteraction) emblaApi.on('pointerUp', startTimer);
        if (options.stopOnMouseEnter) {
            eventStore.add(root, 'mouseenter', ()=>{
                resume = false;
                stopTimer();
            });
            if (!options.stopOnInteraction) eventStore.add(root, 'mouseleave', ()=>{
                resume = true;
                startTimer();
            });
        }
        if (options.stopOnFocusIn) {
            eventStore.add(container, 'focusin', stopTimer);
            if (!options.stopOnInteraction) eventStore.add(container, 'focusout', startTimer);
        }
        eventStore.add(ownerDocument, 'visibilitychange', visibilityChange);
        if (options.playOnInit && !documentIsHidden()) startTimer();
    }
    function destroy() {
        emblaApi.off('pointerDown', stopTimer).off('pointerUp', startTimer);
        stopTimer();
        destroyed = true;
        playing = false;
    }
    function startTimer() {
        if (destroyed) return;
        if (!resume) return;
        if (!playing) emblaApi.emit('autoplay:play');
        const { ownerWindow: ownerWindow } = emblaApi.internalEngine();
        ownerWindow.clearInterval(timer);
        timer = ownerWindow.setInterval(next, options.delay);
        playing = true;
    }
    function stopTimer() {
        if (destroyed) return;
        if (playing) emblaApi.emit('autoplay:stop');
        const { ownerWindow: ownerWindow } = emblaApi.internalEngine();
        ownerWindow.clearInterval(timer);
        timer = 0;
        playing = false;
    }
    function visibilityChange() {
        if (documentIsHidden()) {
            resume = playing;
            return stopTimer();
        }
        if (resume) startTimer();
    }
    function documentIsHidden() {
        const { ownerDocument: ownerDocument } = emblaApi.internalEngine();
        return ownerDocument.visibilityState === 'hidden';
    }
    function play(jumpOverride) {
        if (typeof jumpOverride !== 'undefined') jump = jumpOverride;
        resume = true;
        startTimer();
    }
    function stop() {
        if (playing) stopTimer();
    }
    function reset() {
        if (playing) play();
    }
    function isPlaying() {
        return playing;
    }
    function next() {
        const { index: index } = emblaApi.internalEngine();
        const nextIndex = index.clone().add(1).get();
        const lastIndex = emblaApi.scrollSnapList().length - 1;
        const kill = options.stopOnLastSnap && nextIndex === lastIndex;
        if (kill) stopTimer();
        if (emblaApi.canScrollNext()) emblaApi.scrollNext(jump);
        else emblaApi.scrollTo(0, jump);
    }
    const self = {
        name: 'autoplay',
        options: userOptions,
        init: init,
        destroy: destroy,
        play: play,
        stop: stop,
        reset: reset,
        isPlaying: isPlaying
    };
    return self;
}
$879e3510c4c2d8fa$export$2e2bcd8739ae039.globalOptions = undefined;


const $429f19d41517534c$export$604ab292679fc001 = (emblaApi, prevBtn, nextBtn)=>{
    const scrollPrev = ()=>emblaApi.scrollPrev();
    const scrollNext = ()=>emblaApi.scrollNext();
    prevBtn.addEventListener('click', scrollPrev, false);
    nextBtn.addEventListener('click', scrollNext, false);
    return ()=>{
        prevBtn.removeEventListener('click', scrollPrev, false);
        nextBtn.removeEventListener('click', scrollNext, false);
    };
};
const $429f19d41517534c$export$a607f631c2d9f935 = (emblaApi, prevBtn, nextBtn)=>{
    const togglePrevNextBtnsState = ()=>{
        if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled');
        else prevBtn.setAttribute('disabled', 'disabled');
        if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled');
        else nextBtn.setAttribute('disabled', 'disabled');
    };
    emblaApi.on('select', togglePrevNextBtnsState).on('init', togglePrevNextBtnsState).on('reInit', togglePrevNextBtnsState);
    return ()=>{
        prevBtn.removeAttribute('disabled');
        nextBtn.setAttribute('disabled', 'disabled');
    };
};
const $429f19d41517534c$export$facf7ea5340ed01e = (emblaApi, dotsNode)=>{
    let dotNodes = [];
    const addDotBtnsWithClickHandlers = ()=>{
        dotsNode.innerHTML = emblaApi.scrollSnapList().map(()=>'<button aria-label="carousel pagination button" class="embla__dot" type="button"></button>').join('');
        dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'));
        dotNodes.forEach((dotNode, index)=>{
            dotNode.addEventListener('click', ()=>emblaApi.scrollTo(index), false);
        });
    };
    const toggleDotBtnsActive = ()=>{
        const previous = emblaApi.previousScrollSnap();
        const selected = emblaApi.selectedScrollSnap();
        dotNodes[previous].classList.remove('embla__dot--selected');
        dotNodes[selected].classList.add('embla__dot--selected');
    };
    emblaApi.on('init', addDotBtnsWithClickHandlers).on('reInit', addDotBtnsWithClickHandlers).on('init', toggleDotBtnsActive).on('reInit', toggleDotBtnsActive).on('select', toggleDotBtnsActive);
    return ()=>{
        dotsNode.innerHTML = '';
    };
};
const $429f19d41517534c$export$772a48efac908d10 = (emblaApiMain, emblaApiThumb)=>{
    const slidesThumbs = emblaApiThumb.slideNodes();
    const scrollToIndex = slidesThumbs.map((_, index)=>()=>emblaApiMain.scrollTo(index));
    slidesThumbs.forEach((slideNode, index)=>{
        slideNode.addEventListener('click', scrollToIndex[index], false);
    });
    return ()=>{
        slidesThumbs.forEach((slideNode, index)=>{
            slideNode.removeEventListener('click', scrollToIndex[index], false);
        });
    };
};
const $429f19d41517534c$export$a3ace2c6bbe4b6cd = (emblaApiMain, emblaApiThumb)=>{
    const slidesThumbs = emblaApiThumb.slideNodes();
    const toggleThumbBtnsState = ()=>{
        emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap());
        const previous = emblaApiMain.previousScrollSnap();
        const selected = emblaApiMain.selectedScrollSnap();
        slidesThumbs[previous].classList.remove('embla-thumbs__slide--selected');
        slidesThumbs[selected].classList.add('embla-thumbs__slide--selected');
    };
    emblaApiMain.on('select', toggleThumbBtnsState);
    emblaApiThumb.on('init', toggleThumbBtnsState);
    return ()=>{
        const selected = emblaApiMain.selectedScrollSnap();
        slidesThumbs[selected].classList.remove('embla-thumbs__slide--selected');
    };
};


class $b1c2252fe2969ef5$var$EmblaComponent extends HTMLElement {
    constructor(){
        super();
        this.emblaApi;
        this.emblaApiThumbs;
        this.emblaNode = this.querySelector('.embla');
        this.emblaThumbs = this.querySelector('.embla-thumbs');
        this.viewportNode = this.querySelector('.embla__viewport');
        this.viewportNodeThumbs = this.querySelector('.embla-thumbs__viewport');
        this.prevBtn = this.querySelector('.embla__button--prev');
        this.nextBtn = this.querySelector('.embla__button--next');
        this.dotsNode = this.querySelector('.embla__dots');
        this.progressBar = this.querySelector('.embla__progress__bar');
        this.options = this.returnConfig();
        this.optionsThumbs = this.returnThumbsConfig();
        this.activeSlide = this.querySelector('.embla__slide');
        document.addEventListener('DOMContentLoaded', (e)=>{
            this.extraSlideEls = this.querySelector('embla-extra-slide-els');
            this.initEmbla();
            this.emblaApi.on('select', ()=>this.handleSelect());
            this.handleActiveSlide();
        });
    }
    initEmbla() {
        this.emblaApi = (0, $d65d5652050191ad$export$2e2bcd8739ae039)(this.viewportNode, this.options, this.emblaNode.getAttribute('data-autoplay') === 'true' ? [
            (0, $879e3510c4c2d8fa$export$2e2bcd8739ae039)(this.returnAutoplayConfig())
        ] : null);
        if (this.emblaApi) {
            this.emblaApi.on('select', ()=>this.handleSelect());
            this.handleSelect(); // Ensure the correct slide is active on load
            this.addSlideClickHandlers(); // Add click event to slides
        }
        if (this.viewportNodeThumbs) {
            this.emblaApiThumbs = (0, $d65d5652050191ad$export$2e2bcd8739ae039)(this.viewportNodeThumbs, this.optionsThumbs);
            const prevThumbsBtn = this.querySelector('.embla-thumbs__button--prev');
            const nextThumbsBtn = this.querySelector('.embla-thumbs__button--next');
            if (prevThumbsBtn && nextThumbsBtn) {
                prevThumbsBtn.addEventListener('click', ()=>this.emblaApiThumbs.scrollPrev());
                nextThumbsBtn.addEventListener('click', ()=>this.emblaApiThumbs.scrollNext());
            }
        }
        if (this.prevBtn && this.nextBtn) {
            (0, $429f19d41517534c$export$604ab292679fc001)(this.emblaApi, this.prevBtn, this.nextBtn);
            (0, $429f19d41517534c$export$a607f631c2d9f935)(this.emblaApi, this.prevBtn, this.nextBtn);
        }
        if (this.dotsNode) (0, $429f19d41517534c$export$facf7ea5340ed01e)(this.emblaApi, this.dotsNode);
        if (this.emblaApiThumbs) {
            (0, $429f19d41517534c$export$772a48efac908d10)(this.emblaApi, this.emblaApiThumbs);
            (0, $429f19d41517534c$export$a3ace2c6bbe4b6cd)(this.emblaApi, this.emblaApiThumbs);
        }
    }
    returnConfig() {
        return {
            align: this.emblaNode.getAttribute('data-align') || 'center',
            loop: this.emblaNode.getAttribute('data-loop') === 'true' ? true : false,
            slidesToScroll: +this.emblaNode.getAttribute('data-slides-to-scroll') || 'auto',
            startIndex: +this.emblaNode.getAttribute('data-start-index') || 0,
            containScroll: 'trimSnaps',
            axis: this.emblaNode.getAttribute('data-axis') || 'x',
            duration: +this.emblaNode.getAttribute('data-duration') || 25,
            inViewThreshold: 1
        };
    }
    returnAutoplayConfig() {
        return {
            delay: +this.emblaNode.getAttribute('data-autoplay-speed') || 4000
        };
    }
    returnThumbsConfig() {
        return {
            containScroll: 'keepSnaps',
            dragFree: true,
            loop: this.emblaThumbs?.getAttribute('data-thumbs-loop') === 'true' ? true : false
        };
    }
    handleSelect() {
        if (!this.emblaApi) return;
        const activeIndex = this.emblaApi.selectedScrollSnap();
        const slides = this.querySelectorAll('.embla__slide');
        const videos = this.querySelectorAll('.embla__slide video');
        // Remove active class from all slides
        slides.forEach((slide)=>slide.classList.remove('embla__slide--active'));
        // Pause all videos
        videos.forEach((video)=>{
            video.pause();
            video.currentTime = 0; // Reset video to start
        });
        // Find and activate the new slide
        const newActiveSlide = slides[activeIndex];
        if (newActiveSlide) {
            newActiveSlide.classList.add('embla__slide--active');
            // Play the video inside the active slide
            const videoInActiveSlide = newActiveSlide.querySelector('video');
            if (videoInActiveSlide) videoInActiveSlide.play();
        }
        if (this.progressBar) {
            const totalSlides = this.emblaApi.scrollSnapList().length;
            const progressPercentage = (activeIndex + 1) / totalSlides * 100;
            this.progressBar.style.width = `${progressPercentage}%`;
        }
    }
    addSlideClickHandlers() {
        const slides = this.querySelectorAll('.embla__slide');
        slides.forEach((slide, index)=>{
            slide.addEventListener('click', ()=>{
                if (this.emblaApi) {
                    this.emblaApi.scrollTo(index); // Scroll to clicked slide
                    this.handleSelect(); // Manually trigger handleSelect() to update active state
                }
            });
        });
    }
    handleActiveSlide(newSlide) {
        if (newSlide) {
            this.activeSlide.classList.remove('embla__slide--active');
            this.activeSlide = newSlide;
            this.activeSlide.classList.add('embla__slide--active');
        } else this.activeSlide.classList.add('embla__slide--active');
    }
}
customElements.define('embla-component', $b1c2252fe2969ef5$var$EmblaComponent);
/* functionality for elements that are not part of slides/thumbnails but still need to get toggled when slides change */ class $b1c2252fe2969ef5$var$EmblaExtraSlideEls extends HTMLElement {
    constructor(){
        super();
        this.extraSlideElements = this.querySelectorAll('.embla__extra-slide-el');
        this.showExtraSlideEl('0');
    }
    showExtraSlideEl(index) {
        if (!this.extraSlideElements) return;
        this.extraSlideElements.forEach((extraEl)=>{
            if (extraEl.getAttribute('data-extra-slide-el-index') !== index) extraEl.classList.remove('is-visible');
            else extraEl.classList.add('is-visible');
        });
    }
}
customElements.define('embla-extra-slide-els', $b1c2252fe2969ef5$var$EmblaExtraSlideEls);


document.addEventListener('DOMContentLoaded', function() {
    console.log('theme.js ready');
});

})();
//# sourceMappingURL=theme.js.map
